import api from "./api";
import { AuthResponse } from "../types/Models";

export const handlesLogin = async (
  cpf: string,
  password: string,
  captchaToken: string,
): Promise<AuthResponse> => {
  try {

    const response = await api.post<AuthResponse>("/login", {
      cpf,
      password,
      captcha_token: captchaToken,
    });

    const { token } = response.data;

    sessionStorage.setItem("authToken", token);

    return response.data;
    
  } catch (error) {
    throw new Error("Failed to login");
  }
};
